import * as React from 'react';
import { Tooltip } from 'src/component/Global/Tooltip';
import factoryLeadIcon from "src/assets/images/factory-lead-icon.svg";
import Constants from "../../helper/Constants";
import System from 'src/helper/system';


const FactoryLeadTimeDisplay = (props) => {
    const { single_product, imageShow = true, position = 'top center' } = props;
    const { FactoryLeadTime } = Constants;
    const renderInnerMain = (message) => {
        return (
            imageShow && (
                <Tooltip opener={() => (
                    <i className={'fa fa-exclamation-circle'} />
                )} content={() => (
                    <>
                        {message}
                    </>
                )} position={position}
                />
            )
        )
    };

    return <div className='factory-lead'>
        <div className='additional-title'>
            <div className={'font-bold'}>Additional inventory</div>
            <span> {imageShow && <img className={'me-1'} src={factoryLeadIcon}></img>}
                Factory Lead Time: {(FactoryLeadTime.includes(single_product?.FactoryLeadTime) || single_product?.constrainPartFlag) ?
                    <span>Lead time unavailable {renderInnerMain('Factory Lead Time: Lead time unavailable')}</span> :
                    <span>{System.daysToWeeksAndDays(single_product?.FactoryLeadTime)} {renderInnerMain('For quantities exceeding available inventory, your estimated delivery is based on supplier lead time, shipping method and destination.')}</span>}                             </span>
        </div>
    </div>;
}

export default FactoryLeadTimeDisplay;